import ReactLoading, { LoadingType } from 'react-loading';
import { StyledLoadingOverlay, StyledLoadingIndicator, StyledLoadingMessage } from "./styles";

export interface ILoadingIndicatorProps {
    type: LoadingType,
    color: string,
    height?: any,
    width?: any,
    loading: boolean,
    message?: string,
    top?: number,
    left?: number,
    container?: any,
    onClick?(e: any): void
}

export const LoadingIndicator: React.FC<ILoadingIndicatorProps> = (props) => {
    const { type, color, height, width, loading, onClick, top, left, message } = props;

    return (
        <StyledLoadingOverlay
            loading={ + loading}
            onClick={onClick}
            top={top}
            left={left}
            className='loading-overlay'
        >
            <StyledLoadingIndicator className='loading-indicator'>
                <div>
                    <ReactLoading type={type} color={color} height={height} width={width} />
                </div>
                <StyledLoadingMessage className='loading-message'>{message || "Loading"}</StyledLoadingMessage>
            </StyledLoadingIndicator>
        </StyledLoadingOverlay>
    );
};

